<template>
  <div>
    <v-textarea
      v-bind="$attrs"
      :auto-grow="autoGrow"
      @change="$emit('change', $event)"
      @keyup.esc="$emit('esc')"
      :key="autoGrow"
      :id="textareaId"
    ></v-textarea>
    <v-layout wrap>
      <v-flex xs1>
        <v-tooltip bottom>
          <v-btn
            :small="$vuetify.breakpoint.smAndDown"
            class="ma-0"
            :class="{ 'mt-2': $vuetify.breakpoint.smAndUp }"
            slot="activator"
            icon
            @click="autoGrow = !autoGrow"
          ><v-icon :disabled="!autoGrow">line_weight</v-icon>
          </v-btn>
          <span>Expandir Automaticamente</span>
        </v-tooltip>
      </v-flex>
      <slot></slot>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'SharedTextarea',
  props: {
    textareaId: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    autoGrow: true
  })
}
</script>

<style>

</style>